import { PaymentsActionTypes } from "./actionTypes";

const initialState = {
    paymentsListError: null, message: null,
    query: {
        page: 1,
        pageSize: 20,
        search: ''
    }
}

const ProfPayments = (state = initialState, action) => {
    switch (action.type) {

        case PaymentsActionTypes.PROFPAY_LIST_GET:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: null
            }
            break;
        case PaymentsActionTypes.PROFPAY_LIST_GET_SUCCESSFUL:
            state = {
                ...state,
                invoicingList: action.payload,
                invoicingListError: null
            }
            break;
        case PaymentsActionTypes.PROFPAY_LIST_GET_ERROR:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: action.payload
            }
            break;


        case PaymentsActionTypes.PROFPAY_GET_FILTERED:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: null
            }
            break;
        case PaymentsActionTypes.PROFPAY_GET_FILTERED_SUCCESSFUL:
            state = {
                ...state,
                invoicingList: action.payload,
                invoicingListError: null
            }
            break;
        case PaymentsActionTypes.PROFPAY_GET_FILTERED_ERROR:
            state = {
                ...state,
                invoicingList: null,
                invoicingListError: action.payload
            }
            break;


        case PaymentsActionTypes.PROFPAY_CREATE:
            state = {
                ...state,
                isLoadingAddInvoicing: true
            }
            break;
        case PaymentsActionTypes.PROFPAY_CREATE_SUCCESS:
            state = {
                ...state,
                isLoadingAddInvoicing: false,
            }
            break;
        case PaymentsActionTypes.PROFPAY_CREATE_ERROR:
            state = {
                ...state,
                isLoadingAddInvoicing: false,
            }
            break;

        case PaymentsActionTypes.SET_PROFPAY_QUERY:
            state = {
                ...state,
                query: { ...state.query, ...action.payload }
            }
            break;
        case PaymentsActionTypes.RESET_PROFPAY_QUERY:
            state = {
                ...state,
                query: initialState.query
            }
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}


export default ProfPayments;


